var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.widget.name)?_c('div',{class:['aiaibot-message', {
    'with-padding': !_vm.hideMessage
  }]},[(!_vm.hideMessage)?[(_vm.widget.showIcon)?_c('img',{staticClass:"alva-icon",attrs:{"src":_vm.iconSrc,"alt":"Alva"}}):_vm._e(),_c(_vm.widget.name,_vm._b({tag:"component",on:{"scrollToEnd":function($event){return _vm.$emit('scrollToEnd')}}},'component',_vm.widget,false))]:_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }